import { c as _c } from "react/compiler-runtime";
import { IconSystem } from '#icons/IconSystem';
import styles from './RadioButtonIcon.module.scss';
type Props = {
  selected: boolean;
  className?: string;
};
export function RadioButtonIcon(t0) {
  const $ = _c(4);
  const {
    className,
    selected
  } = t0;
  if (selected) {
    const t1 = `${styles.checkbox} ${styles.selected} ${className ?? ""}`;
    let t2;
    if ($[0] !== t1) {
      t2 = <IconSystem icon="radio-button" variant="outline" className={t1} aria-label={"Radiobuton ausgew\xE4hlt"} />;
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  } else {
    const t1 = `${styles.checkbox} ${className ?? ""}`;
    let t2;
    if ($[2] !== t1) {
      t2 = <IconSystem icon="circle" variant="outline" className={t1} aria-label="Radiobuton" />;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
}